<template>
  <body v-bind:style="[ authorized ? {'background': '#00acc1' , 'display': 'flex',
  'justify-content': 'center',
  'align-items': 'center',
  'width': '100%',
  'min-height': '55vh'} : '' ]">
  <section v-if="authorized && selectedContragent.priceCurrency === 'BYN'">
  <carousel :interval="8000"  class="mt-3 mb-3">
    <!--- <carousel-item img :src="getRandomPicture(0,9)" mask="black-light" alt="1 slide"></carousel-item>
    <carousel-item img :src="getRandomPicture(9,18)" mask="black-light" alt="2 slide"></carousel-item>
    <carousel-item img :src="getRandomPicture(18,26)" mask="black-light" alt="3 slide"></carousel-item>
    -->
    <carousel-item img src="https://b2.belca.by/images/Actions/actiontonerB.jpg"  alt="1 slide"></carousel-item>

  </carousel>
  </section>
  <section v-if="authorized && selectedContragent.priceCurrency === 'RUB'">
  <carousel :interval="8000"  class="mt-3 mb-3">
    <!--- <carousel-item img :src="getRandomPicture(0,9)" mask="black-light" alt="1 slide"></carousel-item>
    <carousel-item img :src="getRandomPicture(9,18)" mask="black-light" alt="2 slide"></carousel-item>
    <carousel-item img :src="getRandomPicture(18,26)" mask="black-light" alt="3 slide"></carousel-item>
    -->

    <carousel-item img src="https://b2.belca.by/images/Actions/actiontonerF.jpg"  alt="1 slide"></carousel-item>
  </carousel>
  </section>
  <section v-if="!authorized" class="index-header animated fadeIn slow">
  <div class="container">
    <div class="row">
      <div class="col-md-12 mt-3">
        <img src="../assets/logo-index.png">
      </div>
    </div>
  </div>
</section>

  <section v-if="!authorized" class="index-header-ornament animated fadeIn slow">
  <div class="container">
    <div class="row">
      <div class="col-md-12"></div>
    </div>
  </div>
  </section>
  <section v-if="!authorized">
  <div class="container">
    <div class="row index-content animated fadeIn slow">
      <div class="col-md-4 index-video">
        <div class="videomain">
          <div class="onescreen_item slide_type_2" style="background:#fff;">
            <div class="horizontal_slide_img slide_up_animate80" style="background:#fff;">
              <video class="onescreen_vid" muted="muted" style="" loop = "1" autoplay="autoplay"><source src="https://belca.by/uploads/video/adv_s2_1.mp4" style="background:#fff;">Your browser does not support the video tag.</video>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</section>
</body>
</template>
<script>
import {
  Btn,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Container,
  NumericInput,
  Row,
  Column,
  Tbl,
  TblHead,
  TblBody,
  Card,
  CardImg,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  CardFooter,
  CardUp,
  CardAvatar,
  CardGroup,
  ViewWrapper,
  MdMask,
  mdbView,
  Fa,
  Carousel,
  CarouselItem,
  CarouselCaption,
  mdbRow,
  mdbContainer,
  mdbCol,
  mdbMedia
} from 'mdbvue'
export default {
  name: 'About',
  data () {
    return {
      placemarks: [
        {
          coords: [53.91, 27.59],
          properties: {}, // define properties here
          options: {}, // define options here
          clusterName: '1',
          balloonTemplate: '<div>"Your custom template"</div>',
          callbacks: { click: function () {} }
        }
      ]
    }
  },
  props: ['authorized', 'ai', 'selectedContragent'],
  mounted () {
    this.$emit('chngai', 0)
  },
  methods: {
    getRandomPicture (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      var pic = ''
      pic = String('https://b2.belca.by/Slider/belca' + Math.floor(Math.random() * (max - min) + min) + '.jpg')
      // console.log(pic)
      return pic
    }
  },
  components: {
    Btn,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Container,
    NumericInput,
    Row,
    Column,
    Tbl,
    TblHead,
    TblBody,
    Card,
    CardImg,
    CardHeader,
    CardBody,
    CardTitle,
    CardText,
    CardFooter,
    CardUp,
    CardAvatar,
    CardGroup,
    ViewWrapper,
    MdMask,
    mdbView,
    Fa,
    Carousel,
    CarouselItem,
    CarouselCaption,
    mdbRow,
    mdbContainer,
    mdbCol,
    mdbMedia
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.row {
    margin-right: -15px;
    margin-left: -15px;
}
  .index-header-ornament {
    background: url(../assets/ornament.png) top left repeat-x;
    height: 80px;
    margin-top: -15px;
    z-index: 10;
}
.index-footer-ornament {
    background: url(../assets/ornament.png) top left repeat-x;
    height: 100px;
    margin-top: -35px;
    z-index: 10;
}
.index-header-bg {
    background: #00acc1;
    padding: 10px 0;
 }

.videomain video {
    width: 90%;
}
.index-content {
    background: url(../assets/bg-body-sm2.png) center center no-repeat;
    padding: 0 0;
    position: relative;
    min-height: 100%;
}
    .index-header {
    background: url(../assets/bg-header1.png) center center no-repeat;
    background-size: cover;
    text-align: center;
    padding: 0 0;
    min-height: 30vh;
}
@media only screen and (max-width: 900px) {
    .mobile-hide {
      display: none !important;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/About.vue